import { Grid, Theme } from '@gemini/fe-ds-core';
import styled from '@emotion/styled';

export const CalendarCard = styled('div')<{ marginTop?: string }>(
  {
    border: '1px solid #d9e4f5',
    borderRadius: '0 0 0.5rem 0.5rem',
  },
  ({ marginTop }) => ({
    marginTop: marginTop,
  }),
);

export const CalendarSection = styled.div<{
  isDays?: boolean;
  isLoading?: boolean;
}>`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  display: flex;
  padding: 0.5rem 1.5rem 1rem 1.5rem;
  align-items: flex-start;
  align-self: stretch;
  gap: 1;
  min-width: 100%;
  justify-content: ${props => (props.isLoading ? 'center' : 'flex-start')};
  /* min-height: ${props => (props.isDays ? '680px' : 'unset')}; */

  @media screen and (max-width: 576px) {
    padding: 0rem 0.5rem 1rem 0.5rem;
    /* min-height: ${props => (props.isDays ? '460px' : 'unset')}; */
  }
  @media screen and (min-width: 767px) and (max-width: 900px) {
    padding: 0rem 0.5rem 1rem 0.5rem;
    /* min-height: ${props => (props.isDays ? '460px' : 'unset')}; */
  }
`;

export const TimerWrapper = styled.div`
  // align-self: flex-end;
`;

export const ChooseNewSlotWrapper = styled.div<{
  isDesktop?: boolean;
}>`
  // align-self: flex-start;

  .MuiTypography-root {
    white-space: ${props => props.isDesktop && 'nowrap'};
  }
`;

export const ReschedulingBannerWrapperText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const CalendarOverlay = styled(Grid)`
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% + 2rem) !important;
  height: calc(100% + 2rem) !important;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  backdrop-filter: blur(2px);
`;

export const MultipatientsSublabelWrapper = styled.div`
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
`;

export const MultipatientsTagslWrapper = styled.div<{
  theme: Theme;
}>(
  {
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '0.5rem',
  },
  ({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  }),
);
